import { WARP_ARRIVAL_LIFT } from '../constants'
import { findPositionByName } from '../sharedHelpers'
import { BehaviorHandler } from '../types'

/**
 * ワープパッドの接触ハンドラ（Lua: WarpScript）。
 *
 * rjf06/07/08 に重複していた「ワープ元に触れたら、対のワープ先の
 * Position + (0, WARP_ARRIVAL_LIFT, 0) へアバターのテレポートを要求する」を
 * 1 箇所へ集約する。持ち上げは Lua の到着先 + Vector3.new(0,5,0)（地面への
 * めり込み回避）の移植。到着先が見つからない（学習者のプログラムが消した等）
 * 場合は何もしない。
 *
 * @param destinationName 到着先のオブジェクト名（例: 'ワープ先#2'）
 */
export const createWarpPadHandler =
  (destinationName: string): BehaviorHandler =>
  ({ world }) => {
    const destination = findPositionByName(world, destinationName)
    if (!destination) {
      return
    }
    world.requestAvatarTeleport({
      x: destination.x,
      y: destination.y + WARP_ARRIVAL_LIFT,
      z: destination.z,
    })
  }
